import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { getAssistant } from "../../features/assistant/assistantSlice";
// import { getToolsName } from "../../features/tools/toolsSlice";
import {
  clearSetting,
  fetchSettingById,
} from "../../features/settings/settingsSlice";

export const useAssistantData = (assistantId, settingId) => {
  const dispatch = useDispatch();

  const { selectedAssistant: assistant } = useSelector(
    (state) => state.assistant,
  );
  const { setting: reduxSetting } = useSelector((state) => state.setting);
  // const { items: tools, loading: toolsLoading } = useSelector(
  //   (state) => state.tools,
  // );
  const [setting, setSetting] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!assistantId) return;
    setSetting(null);
    setLoading(true);
    dispatch(clearSetting());

    const load = async () => {
      try {
        dispatch(getAssistant(assistantId));
        // dispatch(getToolsName(assistantId));

        if (settingId) {
          await dispatch(fetchSettingById({ settingUuid: settingId }));
        }

        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    load();
  }, [assistantId, settingId, dispatch]);

  useEffect(() => {
    if (reduxSetting !== undefined) {
      setSetting(reduxSetting);
    }
  }, [reduxSetting]);

  return {
    assistant,
    setting,
    setSetting,
    loading: loading,
  };
};
